(function () {
  'use strict';

  function getCardData(card) {
    var dataEl = card.querySelector('[data-swatch-data]');
    if (!dataEl) return null;
    try { return JSON.parse(dataEl.textContent); } catch (e) { return null; }
  }

  function getSelectedSwatch(card) {
    var input = card.querySelector('[data-swatches-container] input[name="swatch"]:checked');
    return input ? input.value : null;
  }

  function findVariant(card, sizeValue) {
    var data = getCardData(card);
    var pills = card.querySelector('[data-variant-pills]');
    if (!data || !pills) return null;

    var optionIndex = parseInt(pills.getAttribute('data-option-index'), 10);
    if (!optionIndex) return null;
    var sizeKey = 'option' + optionIndex;
    var colorValue = getSelectedSwatch(card);
    var variants = data.variants || [];

    var matches = variants.filter(function (variant) {
      if (String(variant[sizeKey]) !== String(sizeValue)) return false;
      if (colorValue && String(variant[data.swatchOptionKey]) !== String(colorValue)) return false;
      return true;
    });

    return matches.find(function (variant) { return variant.available; }) || matches[0] || null;
  }

  function setCardVariant(card, variant) {
    if (!variant) return;
    var links = card.querySelectorAll('[data-product-page-link]');
    links.forEach(function (link) {
      var base = link.href.split('#')[0].split('?')[0];
      link.href = base + '?variant=' + encodeURIComponent(variant.id);
    });
    card.setAttribute('data-selected-variant-id', variant.id);
  }

  function updateSizeAvailability(card) {
    var pills = card.querySelector('[data-variant-pills]');
    var data = getCardData(card);
    if (!pills || !data) return;
    var optionIndex = parseInt(pills.getAttribute('data-option-index'), 10);
    var key = 'option' + optionIndex;
    var colorValue = getSelectedSwatch(card);
    var values = pills.querySelectorAll('.productitem--variant-pill-input');

    values.forEach(function (input) {
      var available = (data.variants || []).some(function (variant) {
        if (!variant.available || String(variant[key]) !== String(input.value)) return false;
        return !colorValue || String(variant[data.swatchOptionKey]) === String(colorValue);
      });
      input.disabled = !available;
      input.closest('.productitem--variant-pill-label').classList.toggle('is-unavailable', !available);
    });
  }

  function updatePillLabel(card, value) {
    var pills = card.querySelector('[data-variant-pills]');
    var label = pills && pills.querySelector('[data-variant-pills-label]');
    if (!label) return;
    var name = pills.getAttribute('data-option-name') || 'SIZE';
    label.textContent = name.toUpperCase() + ': ' + value;
  }

  function updateSizeVisibility(card) {
    var pills = card.querySelector('[data-variant-pills]');
    if (!pills) return;
    var row = pills.querySelector('[data-variant-pills-row]');
    var items = pills.querySelectorAll('.productitem--variant-pill-label');
    var more = pills.querySelector('[data-variant-pill-more]');
    if (!row || !items.length) return;

    // Keep every size/weight option available directly on the card.
    // The row is intentionally horizontally scrollable so mobile users can
    // swipe through all options without opening the product page.
    Array.prototype.forEach.call(items, function (item) {
      item.hidden = false;
    });
    if (more) more.hidden = true;
  }

  function initCard(card) {
    if (!card || card.getAttribute('data-variant-combination-pills-ready') === 'true') return;
    var pills = card.querySelector('[data-variant-pills]');
    if (!pills) return;
    var data = getCardData(card);
    if (!data) return;

    card.setAttribute('data-variant-combination-pills-ready', 'true');

    var selectedVariantId = card.getAttribute('data-selected-variant-id');
    var initialVariant = (data.variants || []).find(function (v) { return String(v.id) === String(selectedVariantId); }) || (data.variants || []).find(function (v) { return v.available; }) || data.variants[0];
    var optionIndex = parseInt(pills.getAttribute('data-option-index'), 10);
    var key = 'option' + optionIndex;
    var initialValue = initialVariant && initialVariant[key];
    var initialInput = initialValue && pills.querySelector('input[data-variant-pill-value="' + CSS.escape(String(initialValue)) + '"]');
    if (initialInput) {
      initialInput.checked = true;
      updatePillLabel(card, initialValue);
    }
    updateSizeAvailability(card);

    pills.addEventListener('change', function (event) {
      var input = event.target.closest && event.target.closest('.productitem--variant-pill-input');
      if (!input) return;
      var variant = findVariant(card, input.value);
      if (variant) {
        updatePillLabel(card, input.value);
        setCardVariant(card, variant);
      }
      updateSizeAvailability(card);
    });

    var swatchContainer = card.querySelector('[data-swatches-container]');
    if (swatchContainer) {
      swatchContainer.addEventListener('change', function (event) {
        if (!event.target.matches('input[name="swatch"]')) return;
        var selected = pills.querySelector('.productitem--variant-pill-input:checked');
        if (!selected) return;
        window.setTimeout(function () {
          updateSizeAvailability(card);
          var variant = findVariant(card, selected.value);
          if (variant) setCardVariant(card, variant);
        }, 0);
      });
    }

    updateSizeVisibility(card);
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-product-item]').forEach(initCard);
  }

  function boot() {
    initAll(document);
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.matches && node.matches('[data-product-item]')) initCard(node);
          if (node.querySelectorAll) initAll(node);
        });
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
    window.addEventListener('resize', function () { initAll(document); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
